import React from "react";
import axios from "axios";
import { useNavigate, useParams } from 'react-router-dom';
import { notifications } from '@mantine/notifications';
import { Box, Group, Drawer, Button, Text, useMantineTheme, Paper, Divider, Checkbox, ActionIcon } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_TWO, utils } from "../../utils/globalVariables";
import { getPropInSubLevelRole, safetyDecodeJWT, safeValue, sqlDateToHumanDate, numberFormatter, masaGaransiUtils__1, masaGaransiUtils__2, isoDateToSqlDate, garansiFotoByFlag, getObjectParam2, stringDivider } from "../../utils/globalFunctions";
import { canAccessSeeCustomersPhoneNumber } from "../../utils/accessing";

import ModalResponse from "../../components/general/ModalResponse";
import ModalTakeAction from "../../components/general/ModalTakeAction";
import LabelContentInline from "../../components/general/LabelContentInline";
import PickerDate from "../../components/general/PickerDate";

import GransiFotoDropFile from "./GransiFotoDropFile";
import GaransiTaggedComponent from "./GaransiTaggedComponent";
import GaransiFotoComponent from "./GaransiFotoComponent";
import GaransiSelectedBatalkan from "./GaransiSelectedBatalkan";

const GaransiSelected = ({
  stateData,
  fnSuccessEdit,
  fnClickPhoto
}) => {
  const mountedRef = React.useRef(true);

  const { URI1 } = useParams();
  const navigate = useNavigate();

  const theme = useMantineTheme();
  const { loginContext, handleSetLoginContext } = useLoginContext();

  const notificationId = React.useRef({
    errorGetData: 'garansiSelected-1',
    errorSubmitGaransi: 'garansiSelected-6',
  })

  const [data, setData] = React.useState({
    drawer: false,
    dataInitLoading: false,
    data: [],
    dataFlag: 'idle',

    tanggalKirim: new Date(),

    submitConfirmationModal: false,
    submitLoading: false,
    submitGaransiId: '',

    dataArrayToKlaim: [],

    modalResponse: {
      show: false,
      type: utils.modalResponse.warning,
      hideOnClickOutSide: false,
      content: ''
    }
  });

  React.useEffect(() => {
    return () => {
      mountedRef.current = false;
    }
  }, [])

  const toggleArrayValue = (arr, val) => {
    setData(d => ({ ...d, dataArrayToKlaim: arr.includes(val) ? arr.filter(el => el !== val) : [...arr, val] }))
  };

  const setDataData = ({ stateData, stateShouldUpdateSelectedItems = true }) => {
    if (Array.isArray(stateData) && stateData.length > 0) {
      setData(d => ({
        ...d,
        data: stateData[0],
        dataFlag: true,

        dataArrayToKlaim: stateShouldUpdateSelectedItems ? Object.values(stateData[0].garansi_detil).map(val => val.stock_garansi_detil_id) : d.dataArrayToKlaim
      }))
    } else {
      setData(d => ({
        ...d,
        dataFlag: false,
      }))
    }
  }

  React.useEffect(() => {
    if (URI1) {

      setData(d => ({
        ...d,
        dataInitLoading: true,
        drawer: true,
      }))

      const formDT = new FormData();
      const formDTHeader = { 'Content-Type': 'application/json' }

      formDT.append('json_token', loginContext.syswebapp);
      formDT.append('flag_all', utils.flagAll);
      formDT.append('garansi_id', URI1);
      formDT.append('garansi_item_status', utils.statusItemGaransi.pengajuan_klaim_garansi.value);

      axios({
        method: 'post',
        url: BE_API_TWO + '/select_garansi_by_garansi_id',
        data: formDT,
        headers: formDTHeader,
      }).then((response) => {
        if (!mountedRef.current) return null;

        setData(d => ({ ...d, dataInitLoading: false }));

        if (response.data.flag_status === 'isset') {
          setDataData({
            stateData: response.data.data,
            stateShouldUpdateSelectedItems: true
          });
        }

        if (response.data.flag_status === 'error') {
          notifications.show({
            id: notificationId.current.errorGetData,
            title: utils.notification.warning.caption,
            message: response.data.pesan,
            color: utils.notification.warning.color,
            icon: utils.notification.warning.icon,
            withBorder: true,
            autoClose: true,
          })
        }

        if (response.data.flag_status === 'no-data') {
          navigate(`/${getPropInSubLevelRole(safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappsl'), 'slugLink', '')}/${stateData.stateMenu}/${stateData.stateSubMenu}/${stateData.stateTab}`, { replace: true });

          setData(d => ({ ...d, drawer: false }));

          setData(d => ({
            ...d,
            modalResponse: {
              ...d.modalResponse,
              type: utils.modalResponse.warning,
              hideOnClickOutSide: true,
              content: 'Data tidak ditemukan.',
              show: true
            }
          }))
        }

        if (response.data.flag_status === 'invalid-json-token') {
          handleSetLoginContext(null);
        }

        if (response.data.flag_status === 'user-inactive') {
          handleSetLoginContext(null);
        }
      }).catch(error => {
        if (!mountedRef.current) return null;

        setData(d => ({
          ...d,
          dataInitLoading: false
        }))

        notifications.show({
          id: notificationId.current.errorGetData,
          title: utils.notification.warning.caption,
          message: error.message,
          color: utils.notification.warning.color,
          icon: utils.notification.warning.icon,
          withBorder: true,
          autoClose: true,
        })
      })
    }
  }, [handleSetLoginContext, loginContext, loginContext.syswebapp, navigate, URI1, stateData.stateMenu, stateData.stateSubMenu, stateData.stateTab, stateData.triggerUpdate])

  const closeDrawer = ({ cleanURICustomerId = true }) => {
    if (cleanURICustomerId) {
      navigate(`/${getPropInSubLevelRole(safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappsl'), 'slugLink', '')}/${stateData.stateMenu}/${stateData.stateSubMenu}/${stateData.stateTab}`, { replace: true });
    }

    setData(d => ({ ...d, drawer: false }));
  }

  const isEmptyGaransiPhoto = ({ stateDataArray, stateItemStatus = '', stateDataArrayItemsToProcess = [] }) => {
    let res = true;

    if (Array.isArray(stateDataArray) && stateDataArray.length > 0) {
      const selectedItems = stateDataArray.filter(val => stateDataArrayItemsToProcess.includes(val.stock_garansi_detil_id));

      for (let index = 0; index < selectedItems.length; index++) {
        if (Array.isArray(selectedItems[index].garansi_photos) && selectedItems[index].garansi_photos.length > 0) {
          if (Object.values(selectedItems[index].garansi_photos).filter(val => val.stock_garansi_foto_flag === stateItemStatus).length > 0) {
            res = false;
          } else {
            res = true;
            break;
          }
        } else {
          res = true;
          break;
        }
      }
    }

    return res;
  }

  const submitKlaimGaransi = () => {
    if (data.dataArrayToKlaim.length <= 0) {
      setData(d => ({
        ...d,
        submitConfirmationModal: false,
        modalResponse: {
          ...d.modalResponse,
          type: utils.modalResponse.warning,
          hideOnClickOutSide: true,
          content: 'Pilih (ceklis) item yang akan diklaim terlebih dahulu.',
          show: true
        }
      }))
    } else if (isEmptyGaransiPhoto({
      stateDataArray: data.data.garansi_detil,
      stateItemStatus: utils.statusItemGaransiFoto.sebelum_dikirim_supplier.value,
      stateDataArrayItemsToProcess: data.dataArrayToKlaim
    })) {
      setData(d => ({
        ...d,
        submitConfirmationModal: false,
        modalResponse: {
          ...d.modalResponse,
          type: utils.modalResponse.warning,
          hideOnClickOutSide: true,
          content: 'Upload foto kondisi item terlebih dahulu.',
          show: true
        }
      }))
    } else {
      setData(d => ({ ...d, submitLoading: true }));

      const formDT = new FormData();
      const formDTHeader = { 'Content-Type': 'application/json' }

      formDT.append('json_token', loginContext.syswebapp);

      formDT.append('tanggal_kirim', isoDateToSqlDate(data.tanggalKirim, ''));
      formDT.append('garansi_id', data.submitGaransiId);
      formDT.append('garansi_item_status', utils.statusItemGaransi.pengajuan_klaim_garansi.value);
      formDT.append('garansi_item_status_next', utils.statusItemGaransi.sudah_dikirim_ke_supplier.value);

      formDT.append('garansi_item_array', JSON.stringify(data.dataArrayToKlaim));

      axios({
        method: 'post',
        url: BE_API_TWO + '/garansi_kirim_supplier',
        data: formDT,
        headers: formDTHeader,
      }).then((response) => {
        if (!mountedRef.current) return null;

        setData(d => ({ ...d, submitLoading: false, submitConfirmationModal: false }));

        if (response.data.flag_status === 'isset') {
          navigate(`/${getPropInSubLevelRole(safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappsl'), 'slugLink', '')}/${stateData.stateMenu}/${stateData.stateSubMenu}/${stateData.stateTab}`, { replace: true });

          setData(d => ({ ...d, drawer: false }));

          fnSuccessEdit();
        }

        if (response.data.flag_status === 'error') {
          notifications.show({
            id: notificationId.current.errorSubmitGaransi,
            title: utils.notification.warning.caption,
            message: response.data.pesan,
            color: utils.notification.warning.color,
            icon: utils.notification.warning.icon,
            withBorder: true,
            autoClose: false,
          })
        }

        if (response.data.flag_status === 'no-data') {
          setData(d => ({
            ...d,
            modalResponse: {
              ...d.modalResponse,
              type: utils.modalResponse.warning,
              hideOnClickOutSide: true,
              content: 'Data tidak ditemukan !',
              show: true
            }
          }))
        }

        if (response.data.flag_status === 'invalid-json-token') {
          handleSetLoginContext(null);
        }

        if (response.data.flag_status === 'user-inactive') {
          handleSetLoginContext(null);
        }
      }).catch(error => {
        if (!mountedRef.current) return null;

        setData(d => ({ ...d, submitLoading: false, submitConfirmationModal: false }));

        notifications.show({
          id: notificationId.current.errorSubmitGaransi,
          title: utils.notification.warning.caption,
          message: error.message,
          color: utils.notification.warning.color,
          icon: utils.notification.warning.icon,
          withBorder: true,
          autoClose: false,
        })
      })
    }
  }

  return (
    <React.Fragment>
      <Drawer
        opened={data.drawer}
        onClose={() => closeDrawer({ cleanURICustomerId: true })}
        withCloseButton={false}
        position="left"
        closeOnClickOutside={true}

        title={
          <Group noWrap spacing='xs'>
            <ActionIcon
              size='lg'
              variant="light"
              radius='xl'
              color="blue"
              onClick={() => closeDrawer({ cleanURICustomerId: true })}
            >
              <IconArrowLeft size='1.25rem' stroke={1.5} />
            </ActionIcon>

            <Text>Klaim Garansi</Text>
          </Group>
        }
        size='md'

        styles={() => ({
          title: {
            fontWeight: 'bold',
            textTransform: 'uppercase'
          }
        })}
      >
        {!data.dataInitLoading && data.dataFlag === true &&
          <Box py='md' mb='2rem' sx={{ minHeight: '500px' }}>
            <Text size="sm">
              <LabelContentInline
                stateColLabel={4}
                stateLabel='Supplier'
                stateContent={
                  <Box>
                    <Text>{safeValue(data.data.supplier_name, '-')}</Text>
                    <Text>{safeValue(data.data.supplier_address, '-')}</Text>
                    <Text>{safeValue(data.data.supplier_contact, '-')}</Text>
                  </Box>
                }
                stateDivider={true}
              />

              <LabelContentInline
                stateColLabel={4}
                stateLabel='Tanggal Pembelian'
                stateContent={sqlDateToHumanDate({
                  stateDate: data.data.stock_tanggal_beli,
                  stateWithTime: false,
                  stateLang: 'id',
                  stateIsShort: false,
                  stateDay: false,
                  stateDefaultValue: ' - ',
                  stateDateType: 'day'
                })}
                stateDivider={true}
              />

              <LabelContentInline
                stateColLabel={4}
                stateLabel='Harga Beli'
                stateContent={'Rp ' + numberFormatter({ stateValue: data.data.stock_harga_beli })}
                stateDivider={true}
              />

              <LabelContentInline
                stateColLabel={4}
                stateLabel='Harga Jual'
                stateContent={'Rp ' + numberFormatter({ stateValue: data.data.stock_harga_jual })}
                stateDivider={true}
              />

              <LabelContentInline
                stateColLabel={4}
                stateLabel="Garansi"
                stateContent={
                  <Box>
                    <Text
                      mb='sm'
                      color={masaGaransiUtils__2({
                        stateGaransiType: data.data.stock_masa_garansi_type,
                        stateCanBeClaimed: data.data.can_be_claimed,
                        stateColorCanBeClaimed: '',
                        stateColorCannotBeClaimed: ''
                      }).colorCanBeClaimed}
                    >
                      {masaGaransiUtils__2({
                        stateGaransiType: data.data.stock_masa_garansi_type,
                        stateCanBeClaimed: data.data.can_be_claimed,
                      }).isCanBeClaimedCaption}
                    </Text>

                    <Text>
                      {masaGaransiUtils__1({
                        stateGaransiType: data.data.stock_masa_garansi_type,
                        stateGaransiBulan: data.data.stock_masa_garansi_bulan,
                        stateGaransiHari: data.data.stock_masa_garansi_hari,
                        stateTanggalPembelian: data.data.stock_tanggal_beli,
                        stateShowTanggalPembelian: true,
                      })}
                    </Text>
                  </Box>
                }
                stateDivider={true}
              />

              <LabelContentInline
                stateColLabel={4}
                stateLabel='Pengajuan Klaim'
                stateContent={
                  <Box>
                    <Text color="dimmed">Pengajuan ini bersumber dari :</Text>
                    <Text tt='uppercase' mb='xs'>
                      {getObjectParam2(utils.garansiReference, data.data.stock_garansi_reference, 'caption', '-')}
                    </Text>

                    <Text>
                      No Nota : {stringDivider(data.data.stock_garansi_project_id, [4, 6, 8], '.', ' - ')}
                    </Text>

                    <Text>
                      Client : {data.data.customer_name} {canAccessSeeCustomersPhoneNumber({ stateObject: { subLevel: loginContext } }) ? safeValue(data.data.customer_contact, '') : ''}
                    </Text>

                    <Text mt='md' color="dimmed">Diajukan oleh :</Text>
                    <Text>
                      {data.data.stock_garansi_pengaju_user_name} ({getPropInSubLevelRole(data.data.stock_garansi_pengaju_user_sub_level, 'caption', '-')})
                    </Text>

                    <Text>
                      {sqlDateToHumanDate({
                        stateDate: data.data.stock_garansi_tanggal_pengajuan,
                        stateWithTime: false,
                        stateLang: 'id',
                        stateIsShort: false,
                        stateDay: false,
                        stateDefaultValue: ' - ',
                        stateDateType: 'day'
                      })}
                    </Text>

                    <Text mt='md' color="dimmed">Keterangan :</Text>
                    <Text>{safeValue(data.data.stock_garansi_info, '-')}</Text>
                  </Box>
                }
                stateDivider={true}
              />
            </Text>

            <Box mt='2.5rem'>
              <Text fw='bold' tt='uppercase'>
                Item yang akan diklaim {Array.isArray(data.data.garansi_detil) ? `(${data.data.garansi_detil.length} Item)` : ''}
              </Text>

              {Array.isArray(data.data.garansi_detil) && (data.data.garansi_detil.length > 0) && Object.keys(data.data.garansi_detil).map((keyGD, indexGD) => {
                return (
                  <Box
                    key={keyGD}

                    mt='1rem'
                    mb='1rem'
                    p='xs'

                    sx={(tema) => ({
                      backgroundColor: tema.colorScheme === 'light' ? tema.colors.gray[0] : tema.colors.dark[6],
                      borderRadius: tema.radius.sm,
                      borderWidth: '1px',
                      borderStyle: 'solid',
                      borderColor: tema.colorScheme === 'light' ? tema.colors.gray[4] : tema.colors.dark[4],
                    })}
                  >
                    <Group position="apart">
                      <Text size='sm'>
                        <Checkbox
                          label={`ITEM ${Number(indexGD) + 1} : ${safeValue(data.data.stock_category_name, '-')} ${safeValue(data.data.stock_category_sub_name, '-')} ${safeValue(data.data.garansi_detil[keyGD].stock_serial_number, '')}`}
                          checked={data.dataArrayToKlaim.includes(data.data.garansi_detil[keyGD].stock_garansi_detil_id)}
                          onChange={(event) => {
                            toggleArrayValue(data.dataArrayToKlaim, data.data.garansi_detil[keyGD].stock_garansi_detil_id);
                          }}
                          description=''
                        />
                      </Text>

                      <GaransiSelectedBatalkan
                        stateData={{
                          data: data.data.garansi_detil[keyGD],
                          name: `${safeValue(data.data.stock_category_name, '-')} ${safeValue(data.data.stock_category_sub_name, '-')} ${safeValue(data.data.garansi_detil[keyGD].stock_serial_number, '')}`,
                          referensi: safeValue(data.data.stock_garansi_reference, '')
                        }}

                        fnSuccess={() => {
                          setData(d => ({ ...d, drawer: false }));

                          navigate(`/${getPropInSubLevelRole(safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappsl'), 'slugLink', '')}/${stateData.stateMenu}/${stateData.stateSubMenu}/${stateData.stateTab}`, { replace: true });

                          fnSuccessEdit();
                        }}
                      />
                    </Group>

                    <Divider my='xs' />

                    <Box mt='sm'>
                      <Text color="dimmed" size='sm' fw={500}>
                        Foto Kondisi Item Sebelum Diklaim {garansiFotoByFlag({
                          stateDataArray: data.data.garansi_detil[keyGD].garansi_photos,
                          stateFlagDB: 'stock_garansi_foto_flag',
                          stateFlagUtils: utils.statusItemGaransiFoto.sebelum_dikirim_supplier.value
                        }).length > 0 ? `(${garansiFotoByFlag({
                          stateDataArray: data.data.garansi_detil[keyGD].garansi_photos,
                          stateFlagDB: 'stock_garansi_foto_flag',
                          stateFlagUtils: utils.statusItemGaransiFoto.sebelum_dikirim_supplier.value
                        }).length})` : ''}
                      </Text>

                      <Box mt='sm'>
                        <GaransiFotoComponent
                          stateData={{
                            dataFoto: garansiFotoByFlag({
                              stateDataArray: data.data.garansi_detil[keyGD].garansi_photos,
                              stateFlagDB: 'stock_garansi_foto_flag',
                              stateFlagUtils: utils.statusItemGaransiFoto.sebelum_dikirim_supplier.value
                            }),
                            garansiItemStatus: utils.statusItemGaransi.pengajuan_klaim_garansi.value
                          }}

                          stateWithDeletePhoto={true}
                          fnClickPhoto={fnClickPhoto}
                          fnOnChanged={(dataArray) => {
                            setDataData({
                              stateData: dataArray,
                              stateShouldUpdateSelectedItems: false
                            });
                          }}
                        />

                        <GransiFotoDropFile
                          stateData={{
                            garansiId: data.data.garansi_detil[keyGD].stock_garansi_id,
                            garansiDetilId: data.data.garansi_detil[keyGD].stock_garansi_detil_id,
                            garansiItemStatus: utils.statusItemGaransi.pengajuan_klaim_garansi.value,
                            garansiItemStatusFoto: utils.statusItemGaransiFoto.sebelum_dikirim_supplier.value,
                          }}

                          fnOnAdded={(dataArray) => {
                            setDataData({
                              stateData: dataArray,
                              stateShouldUpdateSelectedItems: false
                            });
                          }}
                        />
                      </Box>
                    </Box>

                    {[utils.garansiReference.project_pengerjaan.value, utils.garansiReference.project_pengerjaan_history.value].includes(data.data.stock_garansi_reference) &&
                      <Box mt='lg'>
                        <GaransiTaggedComponent
                          stateData={{
                            stock_garansi_id: data.data.garansi_detil[keyGD].stock_garansi_id,
                            stock_garansi_detil_id: data.data.garansi_detil[keyGD].stock_garansi_detil_id,

                            stock_garansi_client_id: data.data.stock_garansi_client_id,
                            stock_garansi_project_id: data.data.stock_garansi_project_id,
                            stock_garansi_reference: data.data.stock_garansi_reference,

                            customer_name: data.data.customer_name,

                            isTaggedForClientId: data.data.garansi_detil[keyGD].tagged_client_id,
                            isTaggedForProjectId: data.data.garansi_detil[keyGD].tagged_project_id,

                            garansiItemStatus: utils.statusItemGaransi.pengajuan_klaim_garansi.value
                          }}

                          fnOnChanged={(res) => {
                            setDataData({
                              stateData: res,
                              stateShouldUpdateSelectedItems: false
                            })
                          }}
                        />
                      </Box>
                    }
                  </Box>
                )
              })}
            </Box>

            <Text
              mt='xl'
              tt='uppercase'
              fw='bold'
            >
              Kirim item ke supplier
            </Text>

            <Box
              p='xs'
              mt='xs'
              sx={(tema) => ({
                backgroundColor: tema.colorScheme === 'light' ? tema.colors.gray[0] : tema.colors.dark[6],
                borderRadius: tema.radius.sm,
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: tema.colorScheme === 'light' ? tema.colors.gray[4] : tema.colors.dark[4],
              })}
            >
              <Box
                px='md'
                py='lg'
                mb='lg'
                sx={(tema) => ({
                  backgroundColor: tema.colorScheme === 'light' ? tema.colors.blue[0] : tema.fn.rgba(tema.colors.blue[6], 0.15),
                  borderRadius: tema.radius.sm,
                  borderWidth: '1px',
                  borderStyle: 'solid',
                  borderColor: tema.colorScheme === 'light' ? tema.colors.blue[4] : tema.fn.rgba(tema.colors.blue[6], 0.5),
                })}
              >
                {data.dataArrayToKlaim.length <= 0 ?
                  <Text size='sm'>
                    Pilih item untuk diklaim !
                  </Text>
                  :
                  <Text size='sm'>
                    {`${data.dataArrayToKlaim.length} dari ${data.data.garansi_detil.length} item diatas akan diklaim garansi.`}
                  </Text>
                }
              </Box>

              <Text
                size='sm'
                color='dimmed'
                mb='md'
              >
                Pastikan foto kondisi item sudah diupload sebelum melakukan pengiriman ke supplier.
              </Text>

              <PickerDate
                stateMinDate={null}
                stateDate={data.tanggalKirim}
                stateVariant="default"

                stateStylesInput={{
                  backgroundColor: theme.colorScheme === 'light' ? '#fff' : theme.colors.dark[7]
                }}

                fnSetDate={(val) => setData(d => ({ ...d, tanggalKirim: val }))}

                stateLabel='Tanggal Kirim Ke Supplier'
                statePlaceHolder='Tanggal Kirim'
                stateWithAsterisk={false}
                stateDescription=''
                stateError=''
              />

              <Button
                fullWidth
                mt='md'
                onClick={() => setData(d => ({
                  ...d,
                  submitGaransiId: data.data.stock_garansi_id,
                  submitConfirmationModal: true,
                }))}
              >
                Submit Klaim Garansi
              </Button>
            </Box>
          </Box>
        }

        {!data.dataInitLoading && data.dataFlag === false &&
          <Box py='md' mb='2rem' sx={{ minHeight: '500px' }}>
            <Paper px="md" py='xl'>
              <Text ta='center' size='sm'>Data tidak ditemukan</Text>
            </Paper>
          </Box>
        }

        {data.dataInitLoading &&
          <Box py='md' mb='2rem' sx={{ minHeight: '500px' }}>
            <Paper px="md" py='xl'>
              <Text ta='center' size='sm'>Loading Data..</Text>
            </Paper>
          </Box>
        }
      </Drawer>

      <ModalResponse
        stateShow={data.modalResponse.show}
        fnHide={() => setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            show: false
          }
        }))}

        stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
        stateType={data.modalResponse.type}
        stateContent={data.modalResponse.content}
      />

      <ModalTakeAction
        stateShow={data.submitConfirmationModal}
        fnHide={() => setData(d => ({ ...d, submitConfirmationModal: false }))}

        stateHideOnClickOutSide={true}
        stateTitle={String('Confirmation').toUpperCase()}
        stateOverlayZIndex={201}

        stateButtonClosePx='md'

        stateButtonActionCaption='Submit'
        stateButtonActionPx='xs'
        stateButtonActionColor="blue"
        stateButtonActionLoading={data.submitLoading}
        fnButtonAction={submitKlaimGaransi}
      >
        <Text size='sm'>
          Lakukan klaim garansi ke supplier ?
        </Text>
      </ModalTakeAction>
    </React.Fragment>
  )
}

export default React.memo(GaransiSelected);